import React from 'react';
import { Router, browserHistory } from 'react-router';
import routes from './routes';
import { hydrate, render } from "react-dom";
import SessionWatcher from "./views/Pages/Auth/SessionWatcher";

const rootElement = document.getElementById("root");
const app = (
  <SessionWatcher>
    <Router routes={routes} history={browserHistory} />
  </SessionWatcher>
);

if (rootElement.hasChildNodes()) {
  hydrate(app, rootElement);
} else {
  render(app, rootElement);
}



// WEBPACK FOOTER //
// ./src/index.js